<template>
  <div>
    <el-container>

      <el-dialog title=""
                 v-loading="loginIng"
                 :visible="true"
                 :show-close="false"
                 :fullscreen="true"
                 element-loading-text="微信登录中"
                 center>
        <el-row v-if="!loginIng">
          <el-col :span="8"
                  :offset="8">
            <div style="width:100%;height:60px;"></div>

            <!---注冊--->
            <template>
              <el-row>
                <h2>绑定帐号</h2>
                <h4 style="color:red">为了您账号的安全和使用方便，首次登录请先绑定手机号。</h4>
                <div style="width:100%;height:30px;"></div>
                <el-form :model="regForm"
                         label-position="right"
                         :hide-required-asterisk=true
                         :rules="regRules"
                         action="javascript:void(0)"
                         ref="regForm"
                         label-width="100px"
                         class="demo-regForm">
                  <el-form-item prop="mobile"
                                label="手机号">
                    <el-input v-model="regForm.mobile"
                              :required=true
                              :hide-required-asterisk=true
                              placeholder="输入手机号"
                              clearable></el-input>
                  </el-form-item>

                  <el-form-item prop="imageCaptcha">
                    <el-input v-model="regForm.imageCaptcha"
                              placeholder="图片验证码"
                              clearable>
                      <template slot="append">
                        <el-link type="primary"
                                 :underline=false
                                 @click="toGetImgCaptcha">
                          <img :src="imgCaptcha.img"
                               width="90px" />
                        </el-link>
                      </template>
                    </el-input>
                  </el-form-item>

                  <el-form-item prop="smsCaptchaCode">
                    <el-input v-model="regForm.smsCaptcha"
                              placeholder="短信验证码"
                              clearable>
                      <template slot="append">
                        <el-link type="primary"
                                 @click="toSendSms">发送短信验证码</el-link>
                      </template>
                    </el-input>
                  </el-form-item>

                  <!-- <el-form-item prop="agreeChecked">
                      <div class="agreeContainer">
                        <el-checkbox v-model="accountForm.agreeChecked"></el-checkbox>
                        登录代表您已经同意 <el-link type="primary"
                                 @click="openAgreeDialog"
                                 :underline="false">《用户服务协议》</el-link>和 <el-link type="primary"
                                 :underline="false"
                                 @click="openDisclaimerDialog">《免责声明》</el-link>
                      </div>
                    </el-form-item> -->
                  <el-form-item style="text-align:left">
                    <el-button class="loginBtn"
                               type="primary"
                               native-type="submit"
                               @click="toBind">绑&nbsp;&nbsp;&nbsp;&nbsp;定</el-button>
                    <el-button @click="changeType('login')">取消</el-button>
                  </el-form-item>
                  <el-form-item>
                    &nbsp;
                  </el-form-item>
                </el-form>
                <div style="
                                 width:100%;height:10px;">
                </div>

              </el-row>
            </template>

          </el-col>
        </el-row>
      </el-dialog>
    </el-container>

  </div>
</template>

<script>

import axios from 'axios'
export default {
  name: 'wechat',
  data: function () {
    return {
      loginIng: false,
      regForm: {
        wechatId: ''
      },
      imgCaptcha: {},

      regRules: {
        mobile: [
          { required: true, message: '登录账号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {

  },
  methods: {
    toSendSms () {
      axios.post('/api/web/auth/sendSmsCaptcha', { 'mobile': this.regForm.mobile, 'key': this.imgCaptcha.key, 'imgCaptcha': this.regForm.imageCaptcha })
    },
    toGetImgCaptcha () {
      let _this = this
      axios.get('/api/web/auth/captchaImg?' + Math.random()).then(resp => {
        _this.imgCaptcha = resp.data
      })
    },
    toBind () {
      let _this = this
      let state = this.$route.query.state
      axios.post('/api/web/wechat/bind', this.regForm).then(resp => {
        _this.$store.commit('toFreshUserPrice')
        _this.$store.commit('refreshUserInfo')
        _this.$router.push({ 'path': state })
      })
    }
  },

  mounted () {
    // eslint-disable-next-line no-undef

    let code = this.$route.query.code
    let state = this.$route.query.state
    let _this = this
    if (code) {
      axios.get('/api/web/wechat/login?code=' + code).then(resp => {
        if (resp.data && resp.data.succ) {
          _this.$router.push({ 'path': state })
          _this.$store.commit('toFreshUserPrice')
        } else {
          _this.loginIng = false
          _this.regForm.wechatId = resp.data.wechatId
        }
      })
    }
    this.toGetImgCaptcha()
  }
}
</script>
<style lang="less" scoped>
.demoTitle {
  justify-items: center;
  margin: auto;
  text-align: center;
  color: white;
  font-size: 32px;
  line-height: 155px;
}
.el-card {
  min-width: 400px;
}
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}

.simpleReportImg {
  width: 100%;
  height: 160px;
  background: url("../assets/imgs/simpleReportDemoBg.jpg");
}
.tinyReportImg {
  width: 100%;
  height: 160px;
  background: url("../assets/imgs/tinyReportDemoBg.jpg");
}
.compareReportImg {
  width: 100%;
  height: 160px;
  background: url("../assets/imgs/compareReportDemoBg.jpg");
}
.conceptReportImg {
  width: 100%;
  height: 160px;
  background: url("../assets/imgs/conceptDemoBg.jpg");
}

.reportDemoDesc {
  text-align: center;
  padding: 20px;
  font-size: 0.9rem;

  div {
    width: 340px;
    margin: auto;
    height: 50px;
    justify-content: center;
    justify-items: center;
    align-items: center;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/wechat.vue